import { LocationData } from './types';

export enum LocationSource {
  Cookies = 'cookies',
  Default = 'default',
  Ipaddress = 'ipaddress',
  Zip5 = 'zip5'
}

export enum CookieNames {
  City = 'CVCurrentCity',
  CVAccessToken = 'CVAccessToken',
  CVIdToken = 'CVIdToken',
  IpAddress = 'CVCurrentIpAddress',
  MerchHasLoggedIn = 'MerchHasLoggedIn',
  State = 'CVCurrentState',
  Zip = 'CVCurrentZip'
}

export const DefaultLocation: LocationData = {
  state: 'GA',
  city: 'Atlanta',
  zip: '30303',
  ipAddress: ''
};

export const TwoWeeks = 1209600;
